import dayjs from 'dayjs';

import { convertDateToBE } from 'utils/constants/functions';

export interface IGetOrderByCustomer {
  page?: number;
  pageSize?: number;
  orderId?: string;
  SoId?: string;
  BillingId?: string;
  customerId?: string;
  maincustomerId?: string;
  plantId?: string;
  teamSalesId?: string;
  orderTypeId?: string;
  orderStatus?: string;
  orderType?: string;
  ['createFrom - createTo']?: any[];
}

export const SALES_INVOICE_VARIABLES = {
  getOrderByCustomer: (params: IGetOrderByCustomer) => {
    const {
      customerId,
      orderTypeId,
      orderId,
      plantId,
      teamSalesId,
      orderType,
      maincustomerId,
      BillingId,
      SoId,
      orderStatus,
    } = params;
    const pageSize = params?.pageSize ?? 10;
    const page = params?.page ?? 1;

    return {
      skip: (page - 1) * pageSize,
      take: pageSize,
      input: {
        ...(params['createFrom - createTo']?.[0] && {
          createDateFrom: convertDateToBE(params['createFrom - createTo'][0]),
        }),
        ...(params['createFrom - createTo']?.[0] && {
          createDateTo: convertDateToBE(
            params['createFrom - createTo']?.[1] ??
              dayjs().startOf('day').year(9999),
          ),
        }),
        ...(customerId && { customerId: customerId.trim() }),
        ...(orderType && { orderType: orderType }),
        ...(maincustomerId && { mainCustomerId: maincustomerId.trim() }),
        ...(BillingId && { BillingId: BillingId.trim() }),
        ...(SoId && { SoId: SoId.trim() }),
        ...(orderStatus && { orderStatus }),
        ...(teamSalesId && { teamSalesId }),
        ...(plantId && { plantId }),
        ...(orderId && { orderId: orderId.trim() }),
        ...(orderTypeId && { orderTypeId }),
      },
    };
  },
};
